const baseUrl = import.meta.env.VITE_API_BASE_URL;

export const register = async (
  email: string,
  password: string,
  tenantSlug?: string | null,
) => {
  const body: { email: string; password: string; tenantSlug?: string } = {
    email,
    password,
  };
  if (tenantSlug) {
    body.tenantSlug = tenantSlug;
  }

  const response = await fetch(`${baseUrl}/auth/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }
  return response.json();
};

export const login = async (email: string, password: string) => {
  const response = await fetch(`${baseUrl}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  return response.json();
};

export const requestPasswordReset = async (email: string) => {
  const response = await fetch(`${baseUrl}/auth/request-password-reset`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }

  return response.json();
};

export const resetPassword = async (token: string, newPassword: string) => {
  const response = await fetch(`${baseUrl}/auth/reset-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, newPassword }),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }

  return response.json();
};

export const confirmEmail = async (token: string) => {
  const response = await fetch(`${baseUrl}/auth/confirm-email`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token }),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }

  return response.json();
};

export const acceptInvite = async (token: string, password: string) => {
  const response = await fetch(`${baseUrl}/tenants/invites/accept`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, password }),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(errorResponse.error);
  }

  return response.json();
};
